import { defineComponent as _defineComponent } from 'vue'
import { computed, nextTick, onBeforeUnmount, onMounted, ref, watch } from 'vue';
import ExpandToggleButton from '@/_core/shared/ui/ExpandToggleButton/ExpandToggleButton.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Accordion',
  props: {
    maxHeight: { default: 150 },
    maxDesktopHeight: { default: 230 },
    value: { type: Boolean, default: undefined },
    hideToggle: { type: Boolean, default: false }
  },
  emits: ["input", "overflow-change"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'input', value: boolean): void;
  (e: 'overflow-change', isOverflowing: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { maxHeight: number, maxDesktopHeight: number, value: boolean, hideToggle: boolean };

const DESKTOP_BREAKPOINT_QUERY = '(min-width: 1024px)';
const OVERFLOW_EPSILON_PX = 1;





const internalExpanded = ref(false);
const isControlled = computed(() => props.value !== undefined);
const isExpanded = computed(() => (isControlled.value ? !!props.value : internalExpanded.value));

function setExpanded(next: boolean) {
  emit('input', next);
  if (!isControlled.value) {
    internalExpanded.value = next;
  }
}

function toggleExpanded() {
  setExpanded(!isExpanded.value);
}

const isOverflowing = ref(false);
const contentEl = ref<HTMLElement | null>(null);

let resizeObserver: ResizeObserver | null = null;

function checkOverflow() {
  const el = contentEl.value;
  if (!el) return;

  const isDesktop = window.matchMedia(DESKTOP_BREAKPOINT_QUERY).matches;
  const threshold = isDesktop ? props.maxDesktopHeight : props.maxHeight;

  isOverflowing.value = el.scrollHeight > threshold + OVERFLOW_EPSILON_PX;
}

function handleWindowResize() {
  checkOverflow();
}

watch(isOverflowing, (next) => {
  emit('overflow-change', next);
});

onMounted(async () => {
  await nextTick();
  checkOverflow();
  emit('overflow-change', isOverflowing.value);

  if (contentEl.value && typeof ResizeObserver !== 'undefined') {
    resizeObserver = new ResizeObserver(() => checkOverflow());
    resizeObserver.observe(contentEl.value);
  }

  window.addEventListener('resize', handleWindowResize);
});

onBeforeUnmount(() => {
  if (resizeObserver) {
    resizeObserver.disconnect();
    resizeObserver = null;
  }
  window.removeEventListener('resize', handleWindowResize);
});

return { __sfc: true,DESKTOP_BREAKPOINT_QUERY, OVERFLOW_EPSILON_PX, props, emit, internalExpanded, isControlled, isExpanded, setExpanded, toggleExpanded, isOverflowing, contentEl, resizeObserver, checkOverflow, handleWindowResize, ExpandToggleButton }
}

})